import React, { Component } from "react";
import { Field } from "formik";
import ColorField from "./fields/ColorField";
import SelectField from "./fields/SelectField";
import CheckField from "./fields/CheckField";
import SliderField from "./fields/SliderField";
import { Fieldset } from "../theme/styled";
import styled from "styled-components";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

const PickerMain = styled.div`
  > span {
    min-width: 80px;
  }
  .circle-picker {
    margin-top: 0;
  }
`;

class FieldsCommon extends Component {
  render() {
    const { intl, field } = this.props;
    const { ballBlock } = field.options;
    return (
      <Fieldset>
        <h2>
          <FormattedMessage
            id="elements.title"
            defaultMessage="Elementy boiska"
          />
        </h2>
        <Field
          name="wicket"
          component={CheckField}
          label={intl.formatMessage({
            id: "elements.wicket",
            defaultMessage: "Furtka",
          })}
        />
        <Field
          name="ballBlock"
          component={CheckField}
          label={intl.formatMessage({
            id: "elements.ballblocker",
            defaultMessage: "Piłkochwyt",
          })}
        />
        {ballBlock ? (
          <Field
            name="pilkochwyt"
            component={SelectField}
            label={intl.formatMessage({
              id: "elements.ballblockerHeight",
              defaultMessage: "Wysokość",
            })}
            options={[
              {
                value: "4m",
                name:
                  "4" +
                  intl.formatMessage({
                    id: "meter.plural",
                    defaultMessage: " metry",
                  }),
              },
              {
                value: "5m",
                name:
                  "5" +
                  intl.formatMessage({
                    id: "meter.plural",
                    defaultMessage: " metrów",
                  }),
              },
              {
                value: "6m",
                name:
                  "6" +
                  intl.formatMessage({
                    id: "meter.plural",
                    defaultMessage: " metrów",
                  }),
              },
            ]}
          />
        ) : null}
        <Field
          name="unihockey"
          component={SliderField}
          label={intl.formatMessage({
            id: "elements.unihockey",
            defaultMessage: "Bramki do unihokeja (1-2)",
          })}
          min={0}
          max={2}
        />
        <PickerMain>
          <Field name="color" component={ColorField} />
        </PickerMain>
      </Fieldset>
    );
  }
}

const mapState = ({ field }) => ({ field });
FieldsCommon = connect(mapState)(FieldsCommon);
export default injectIntl(FieldsCommon);
